module.exports = __webpack_public_path__ + "media/images/amenities_icons/onsite-barista-716e3d9dfe7de8e132e612de3c0afc04.svg";